// The public Vodin download on the login page (07.10.2026): what the hub
// offers under GET /api/Updates/setup/latest, parsed once at the edge.

export type SetupOffer = {
    version: string,
    fileName: string,
    sha256: string,
    size: number,
};

const isText = (value: unknown): value is string => typeof value === "string" && value.length > 0;

/** The offer, or null for anything that is not one. */
export function parseOffer(json: unknown): SetupOffer | null {
    if (typeof json !== "object" || json === null) {
        return null;
    }
    const { version, fileName, sha256, size } = json as Record<string, unknown>;
    return isText(version) && isText(fileName) && isText(sha256) && /^[0-9a-f]{64}$/.test(sha256)
        && typeof size === "number" && Number.isFinite(size) && size > 0
        ? { version, fileName, sha256, size }
        : null;
}

/** "235 MB" - whole megabytes, as a download button wants it. */
export const sizeLabel = (bytes: number): string => `${Math.max(1, Math.round(bytes / 1_000_000))} MB`;

export const downloadPath = (api: string): string => `${api}/Updates/setup/latest/download`;
export const offerPath = (api: string): string => `${api}/Updates/setup/latest`;
